import {CreateQuotationFromDesignModalProps} from "./types";
import Modal from "@ui-components/Modal";
import {FormattedMessage, useIntl} from "react-intl";
import {useState} from "react";
import SearchSelect from "@ui-components/SearchSelect";
import Button from "@ui-components/Button";

export const CreateQuotationFromDesignModal = ({
  quotationServices,
  onConfirm,
  onClose,
  submitting,
}: CreateQuotationFromDesignModalProps) => {

  // hooks
  const intl = useIntl();

  // state
  const [selected, setSelected]
    = useState(quotationServices[0]?.id || null)

  // utilities
  const options = quotationServices
    .map(({id, name}) => ({value: id, label: name}));

  return (
    // @ts-ignore
    <Modal
      onExit={onClose}
    >
      <h2 className="text-2xl">
        <FormattedMessage id="create_quotation_survey" />
      </h2>
      <div className="my-5">
        {/*@ts-ignore*/}
        <SearchSelect
          label={intl.formatMessage({id: "select_quotation_service"})}
          options={options}
          onChange={({value}: {value: number}) => { setSelected(value); }}
          value={options.find(({value}: {value: number}) => selected === value)}
        />
      </div>
      <div className="grid sm:grid-cols-2 gap-2">
        <Button
          full
          styleType="empty"
          onClick={onClose}
        >
          <FormattedMessage id="cancel" />
        </Button>
        <Button
          full
          onClick={() => {
            if (!selected && selected !== 0) return
            onConfirm(selected).then();
          }}
          submitting={submitting}
        >
          <FormattedMessage id="confirm" />
        </Button>
      </div>
    </Modal>
  )
}